import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Form, Input, Button, Typography, Divider, Alert, Space, Card } from 'antd';
import { login } from '../actions/userActions';
import MicrosoftOAuth from '../components/auth/MicrosoftOAuth.component';
import Logo from '../components/logo/Logo.Component';

const { Text, Link: TypeLink, Title } = Typography;

const LoginScreen = () => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  const userLogin = useSelector((state) => state.userLogin);
  const { error, userInfo } = userLogin;
  const redirect = location.search ? location.search.split('=')[1] : '/user_dashboard';

  useEffect(() => {
    if (userInfo) {
      if (userInfo.requiresTOTP) {
        navigate('/2fauth');
      } else {
        navigate(redirect);
      }
    }
  }, [userInfo, navigate, redirect]);

  const onFinish = async (values) => {
    setLoading(true);
    await dispatch(login(values.email, values.password));
    setLoading(false);
  };


  return (
    <Space direction="vertical" size="middle" style={{ width: '100%' }}>
      <div style={{ textAlign: 'center', marginBottom: '16px' }}>
        <Logo mode="text" />
      </div>
      <Card style={{ borderRadius: 16 }} bodyStyle={{ padding: 32 }}>
        <Title level={3} style={{ textAlign: 'center', marginBottom: 24 }}>
          Log in to your account
        </Title>
        {error && (
          <Alert
            message={t("Error")}
            description={error}
            type="error"
            showIcon
            closable
            style={{ marginBottom: 16 }}
          />
        )}
      
        <div style={{ width: '100%', marginTop: 16 }}>
          <MicrosoftOAuth />
        </div>
        <Divider plain>{t('Or continue with email')}</Divider>
        <Form
          form={form}
          name="login"
          onFinish={onFinish}
          layout="vertical"
        >
          <Form.Item
            name="email"
            label="Email"
            rules={[
              { required: true, message: t('login.emailRequired') },
              { type: 'email', message: t('login.invalidEmail') }
            ]}
          >
            <Input size="large" placeholder={t('login.emailPlaceholder')} />
          </Form.Item>
          <Form.Item
            name="password"
            label={
              <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
                <span>{t('login.password')}</span>
                <Link to="/user_reset_password_setup" style={{ fontSize: '14px', marginLeft: '12px'  }}>
                  {t('login.forgotPassword')}
                </Link>
              </div>
            }
            rules={[{ required: true, message: t('login.passwordRequired') }]}
          >
            <Input.Password size="large" placeholder="••••••••" />
          </Form.Item>
          <Form.Item>
            <Button type="primary" htmlType="submit" block loading={loading} size="large">
              {t('login.signIn')}
            </Button>
          </Form.Item>
        </Form>
        <div style={{ textAlign: 'center', marginTop: 16 }}>
          <Text type="secondary">
            {t('login.noAccount')} <Link to="/usersignup">{t('login.signUp')}</Link>
          </Text>
          <div style={{ marginTop: 8 }}>
            <Link to="/home">Public site</Link>
          </div>
        </div>
        <Text type="secondary" style={{ fontSize: '12px', textAlign: 'center', display: 'block', marginTop: 16 }}>
          By continuing, you agree to our{' '}
          <TypeLink href="https://aro.tech/terms">Terms and Conditions</TypeLink> and{' '}
          <TypeLink href="https://aro.tech/privacy-policy">Privacy Policy</TypeLink>
        </Text>
      </Card>
    </Space>
  );
};

export default LoginScreen;
